import React, { useEffect, useState, useRef } from "react";
import NotificationModal from "./NotificationModal";
import "./NotificationToast.css";

export default function NotificationToast() {

  const [toasts, setToasts] = useState([]);
  const [selectedNotif, setSelectedNotif] = useState(null);

  const timeouts = useRef(new Map());

  useEffect(() => {

    const timeoutMap = timeouts.current;

    const handler = (e) => {

      const notif = e.detail;

      const id = crypto.randomUUID();

      const toast = {
        id,
        title: notif.notification?.title || "Notification",
        value: notif.notification?.value || 1,
        notification: notif.notification
      };

      setToasts(prev => {

        const next = [...prev, toast];

        // MAX 3 TOAST
        if (next.length > 3) {

          const removed = next.shift();

          const timeout = timeoutMap.get(removed.id);
          if (timeout) clearTimeout(timeout);

          timeoutMap.delete(removed.id);

        }

        return next;

      });

      const timeout = setTimeout(() => {

        setToasts(prev => prev.filter(t => t.id !== id));
        timeoutMap.delete(id);

      }, 5000);

      timeoutMap.set(id, timeout);

    };

    window.addEventListener("new-notification", handler);

    return () => {

      window.removeEventListener("new-notification", handler);

      timeoutMap.forEach(timeout => clearTimeout(timeout));
      timeoutMap.clear();

    };

  }, []);

  return (

    <>
      <div className="notification-toast-container">

        {toasts.map(t => (

          <div
            key={t.id}
            className={`notification-toast value-${t.value}`}
            onClick={() => setSelectedNotif(t.notification)}
          >
            {t.title}
          </div>

        ))}

      </div>

      {selectedNotif && (
        <NotificationModal
          notification={selectedNotif}
          onClose={() => setSelectedNotif(null)}
        />
      )}

    </>

  );

}